import { render, staticRenderFns } from "./AdminStoreNotifySlack.vue?vue&type=template&id=104b805a&"
import script from "./AdminStoreNotifySlack.vue?vue&type=script&lang=js&"
export * from "./AdminStoreNotifySlack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports